import { render, staticRenderFns } from "./OTP2FAContent.vue?vue&type=template&id=cf6e896e&scoped=true"
import script from "./OTP2FAContent.vue?vue&type=script&lang=js"
export * from "./OTP2FAContent.vue?vue&type=script&lang=js"
import style0 from "./OTP2FAContent.vue?vue&type=style&index=0&id=cf6e896e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6e896e",
  null
  
)

export default component.exports